import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const H3 = ({ children, className }) =>
  <h3 className={classNames('H3', className)}>
    {children}
  </h3>;

H3.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

H3.defaultProps = {
  className: null,
};

export default H3;



// WEBPACK FOOTER //
// ./src/components/H3/index.js